import React, {  useEffect } from "react";
import Checkbox from "components/checkbox";
import Card from "components/card";

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { MdDelete, MdEdit} from "react-icons/md";
import CopyCell from "common/copycell";

function GateWayTable(props) {
  const { tableData,setOpen,setSingleData,deleteApp } = props;
  const [sorting, setSorting] = React.useState([]);
  let defaultData = tableData;
  const columns = [
//     columnHelper.accessor("app_id", {
//       id: "app_id",
//       header: () => (
//     <p className="text-sm font-bold text-gray-600 dark:text-white">APP ID</p>
//       ),
//     cell: (info) => {
//   const arr = info.getValue() || [];
//   const [ checkedFlag] = arr;
//   return (
//     <div className="flex items-center">
//       <Checkbox
//         isChecked={checkedFlag === 'true'}
//         colorScheme="brandScheme"
//         me="10px"
//       />
//       <p className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
//         {arr}
//       </p>
//     </div>
//   );
// },

//     }),
    columnHelper.accessor("gateway_name", {
      id: "gateway_name",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          GATEWAY NAME
        </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("secret_key", {
      id: "secret_key",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          SECRET KEY
        </p>
      ),
      cell: (info) => (
        <div className="text-sm font-bold text-navy-700 dark:text-white">
          <CopyCell value={info.getValue()} />
        </div>
      ),
    }),
    columnHelper.accessor("publishing_key", {
      id: "publishing_key",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          PUBLISHING KEY
        </p>
      ),
      cell: (info) => (
        <div className="text-sm font-bold text-navy-700 dark:text-white">
         <CopyCell value={info.getValue()} />
        </div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          CREATED DATE
        </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {new Date(info.getValue()).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })}   
        </p>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      id: "updatedAt",
      header: () => ( 
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          UPDATED DATE
        </p>
      ),
      cell: (info) => ( 
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {new Date(info.getValue()).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",   
            day: "2-digit",
          })}
        </p>
      ),  
    }),
    columnHelper.accessor("mode", {
      id: "mode",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white"> 
          MODE
        </p>
      ),
      cell: (info) => ( 
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }), 
     columnHelper.accessor("is_active", {
      id: "is_active",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white"> 
          STATUS
        </p>
      ),
      cell: (info) => ( 
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue() ? "Active" :"InActive"}
        </p>
      ),
    }), 
      columnHelper.accessor("action", {
      id: "action",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white"> 
          ACTION
        </p>
      ),
      cell: (info) => ( 
        <p className="text-sm font-bold text-navy-700 dark:text-white flex items-center gap-2" role="button">
     <MdEdit onClick={()=>{
      setSingleData(info.row.original);
      setOpen(true);
     }} />
     <MdDelete onClick={()=>{
      deleteApp(info.row.original._id);
     }} />
        </p>
      ),
    }), 
  ]; // eslint-disable-next-line
  const [data, setData] = React.useState(() => [...defaultData]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });
  useEffect(() => {
    setData(() => [...defaultData]); 
  }, [defaultData]);

  return (
    <Card extra={"w-full h-full sm:overflow-auto px-6"}>
      <header className="relative flex items-center justify-between pt-4">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          GateWay List
        </div>

        {/* <CardMenu /> */}
      </header>

      <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id} className="!border-px !border-gray-400">
                {headerGroup.headers.map((header) => {
                  return (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      onClick={header.column.getToggleSortingHandler()}
                      className="cursor-pointer border-b-[1px] border-gray-200 pt-4 pb-2 pr-4 text-start"
                    >
                      <div className="items-center justify-between text-xs text-gray-200">
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {{
                          asc: "",
                          desc: "",
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody>
            {table
              .getRowModel()
              .rows.slice(0, 5)
              .map((row) => {
                return (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <td
                          key={cell.id}
                          className="min-w-[150px] border-white/0 py-3  pr-4"
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}

export default GateWayTable;
const columnHelper = createColumnHelper();
